import styled from 'vue-styled-components';


import GridItem from "@/components/MethodsGrid/GridItem";

const GridWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  box-sizing: border-box;
`

GridWrapper.Item = GridItem;

export default  GridWrapper;